import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x, nothing as A } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';

const DEFAULT_DISABLE_BORDER = false;
const DEFAULT_INLINE = Inline.at512;
/**
 * Providence Form Actions component.
 * @see {@link https://providence.fmr.com/4.x/components/form-actions/form-actions.html|Form Actions documentation}
 */
class PvdFormActions extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        //#endregion
        // #region LitElement properties
        this.pvdDisableBorder = DEFAULT_DISABLE_BORDER;
        this.pvdInline = DEFAULT_INLINE;
        // #endregion
    }
    // #endregion
    // #region LitElement lifecycles
    renderText() {
        return x `<s-slot name="text">${this.pvdText ? x `<p class="pvd-form-actions__text">${this.pvdText}</p>` : A}</s-slot>`;
    }
    renderPrimaryAction() {
        return x `<div class="pvd-form-actions__actions-primary"><s-slot name="primary-action"></s-slot></div>`;
    }
    renderSecondaryAction() {
        return x `<div class="pvd-form-actions__actions-secondary"><s-slot name="secondary-action"></s-slot></div>`;
    }
    renderTertiaryAction() {
        return x `<div class="pvd-form-actions__actions-tertiary"><s-slot name="tertiary-action"></s-slot></div>`;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-form-actions-root`,
            modifierPrefix: 'pvd-form-actions',
            modifiers: [
                {
                    condition: this.pvdDisableBorder,
                    className: 'disable-border',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: `inline-${this.pvdInline}`,
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}">${this.renderText()}<div class="pvd-form-actions__actions"><div class="pvd-form-actions__actions-primary-secondary">${this.renderPrimaryAction()} ${this.renderSecondaryAction()}</div>${this.renderTertiaryAction()}</div></div>`;
    }
}
//#region Component configuration
PvdFormActions.componentName = 'form-actions';
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-disable-border',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-disable-border'),
    }),
    __metadata("design:type", Boolean)
], PvdFormActions.prototype, "pvdDisableBorder", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-inline' }),
    __metadata("design:type", String)
], PvdFormActions.prototype, "pvdInline", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-text' }),
    __metadata("design:type", String)
], PvdFormActions.prototype, "pvdText", void 0);

export { DEFAULT_DISABLE_BORDER, DEFAULT_INLINE, PvdFormActions };
//# sourceMappingURL=pvd-form-actions.js.map
